/*
 * https://dev.wix.com/docs/rest/assets/media/media-manager/non-platformize-media-file-url-conversion
 */
const acceptedDomains = [/^files\.wix\.com$/,
// Wix Files
/^static\.wixstatic\.com$/,
// Wix Static (for picture/shape and 3D)
/^video\.wixstatic\.com$/,
// Wix Video
/^music\.wixstatic\.com$/,
// Wix Music
/^publicmedia\.wix\.com$/,
// Public media
/^pix\.wix\.com$/,
// Wix Pix
/^[a-z0-9]+\.usrfiles\.com$/,
// User-specific site_id (for archives and documents)
/^download-files\.wixmp\.com$/];
const isValidHttpsUrl = url => url.startsWith('https://');
const isAcceptedDomain = hostname => acceptedDomains.some(domainPattern => domainPattern.test(hostname));
const hasInvalidCharacters = url => /[|[\] ]/.test(url);
const hasInvalidEncoding = url => {
  try {
    decodeURIComponent(url);
    return false;
  } catch {
    return true;
  }
};
export const withFileUsedParam = (url, options) => {
  if (!url) {
    return '';
  }
  if (!isValidHttpsUrl(url) || hasInvalidCharacters(url) || hasInvalidEncoding(url)) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    if (!isAcceptedDomain(urlObj.hostname)) {
      return url;
    }
    urlObj.searchParams.set('fileUsed', 'false');
    return urlObj.toString();
  } catch (error) {
    options == null || options.logger(new Error("Failed to append 'fileUsed=false' parameter", {
      cause: error
    }));
    return url;
  }
};
//# sourceMappingURL=withFileUsedParam.js.map